import _ from "lodash";

interface PicklistValueItem {
  value: string;
  label: string;
  parentValue?: string;
}

interface PicklistField {
  name: string;
  picklistValues: PicklistValueItem[];
}

export interface PicklistEntity {
  entityType: string;
  fields: PicklistField[];
}

export const getPicklistValue = (picklist: PicklistEntity[], entityType: string, name: string, id?: string | number): PicklistValueItem => {
  const targetPicklist = _.find(picklist, (p) => {
    return p.entityType.toUpperCase() === entityType.toUpperCase();
  });

  const targetOptions = _.find(targetPicklist?.fields, (p) => {
    return p.name.toUpperCase() === name.toUpperCase();
  });

  if (!targetOptions) {
    return {
      label: "",
      value: "",
    };
  }

  const picklistValue = _.find(targetOptions.picklistValues, (plv) => {
    return plv.value.toString().toUpperCase() === id?.toString().toUpperCase();
  });

  if (!picklistValue) {
    return {
      label: "",
      value: "",
    };
  }

  return picklistValue;
};

export const getPicklistValues = (picklist: PicklistEntity[], entityType: string, name: string): PicklistField => {
  const defaultField: PicklistField = {
    name,
    picklistValues: [],
  };

  if (!picklist || picklist.length === 0) {
    return defaultField;
  }

  const targetPicklist = _.find(picklist, (p) => {
    return p.entityType.toUpperCase() === entityType.toUpperCase();
  });

  if (!targetPicklist) {
    return defaultField;
  }

  const field = _.find(targetPicklist.fields, (p: PicklistField) => {
    return p.name.toUpperCase() === name.toUpperCase();
  });

  return field ?? defaultField;
};

export const getPicklistValueByLabel = (
  picklist: PicklistEntity[],
  entityType: string,
  fieldName: string,
  label: string
): PicklistValueItem | undefined => {
  const { picklistValues } = getPicklistValues(picklist, entityType, fieldName);
  const picklistValue = picklistValues.find((iss: PicklistValueItem) => iss.label === label);

  return picklistValue;
};

export const getPicklistValuesByParentValue = (
  picklist: PicklistEntity[],
  entityType: string,
  fieldName: string,
  parentValue: string
): PicklistValueItem[] => {
  const { picklistValues } = getPicklistValues(picklist, entityType, fieldName);

  return picklistValues.filter((iss: PicklistValueItem) => iss.parentValue === parentValue);
};

export const getPicklistValuesByIds = (picklist: PicklistEntity[], entityType: string, name: string, ids: number[]): PicklistValueItem[] => {
  const targetPicklist = _.find(picklist, (p) => {
    return p.entityType.toUpperCase() === entityType.toUpperCase();
  });

  const picklistValues = _.find(targetPicklist?.fields, (p: PicklistField) => {
    return p.name.toUpperCase() === name.toUpperCase();
  })?.picklistValues ?? [];

  return picklistValues.filter((pv) => ids.indexOf(parseInt(pv.value)) >= 0);
};
